"use client";

import React, { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const statsData = [{
  value: 98,
  suffix: "%",
  label: "Success Rate"
}, {
  value: 25,
  suffix: "+",
  label: "Years Expertise"
}, {
  value: 5,
  suffix: "k+",
  label: "Procedures"
}, {
  value: 100,
  suffix: "%",
  label: "Family Focused"
}];
const Counter = ({
  end,
  suffix,
  label,
  isVisible,
  index
}: {
  end: number;
  suffix: string;
  label: string;
  isVisible: boolean;
  index: number;
}) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    if (end === 0) {
      setCount(0);
      return;
    }
    let start = 0;
    const duration = 2000;
    const increment = end / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [end, isVisible]);
  return <div data-section-id="141666" data-index={index} className="flex flex-col items-center justify-center p-6 text-center relative z-10">
      <div className="text-5xl sm:text-6xl lg:text-7xl font-bold text-primary mb-4 tracking-tighter [text-shadow:0_0_40px_rgba(38,208,206,0.3)] transition-all duration-700">
        {count}
        {suffix}
      </div>
      <div className="text-sm sm:text-base text-muted-foreground font-semibold uppercase tracking-widest">
        {label}
      </div>
    </div>;
};
export default function ByTheNumbers() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="clinical-excellence-metrics" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32 border-y border-border/10" ref={ref}>
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='160' height='160' viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext x='50%25' y='50%25' font-size='48' font-weight='900' fill='%23ffffff' font-family='Outfit, sans-serif' text-anchor='middle' dominant-baseline='middle'%3ENF%3C/text%3E%3C/svg%3E")`,
      backgroundSize: "160px 160px"
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-primary/5 to-background pointer-events-none" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,var(--background)_100%)] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 divide-y sm:divide-y-0 sm:divide-x divide-border/20">
          {statsData.map((stat, i) => <Counter key={i} index={i} end={stat.value} suffix={stat.suffix} label={stat.label} isVisible={isVisible} />)}
        </div>
      </div>
    </section>;
}